module.exports = __webpack_public_path__ + "static/media/DOUBLE_WELTEDX2.20e668ea.svg";